import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import * as auth from "./Auth"
import {http_auth, REFRESH_TOKEN} from "../../utility/Utils"

export const saveData = createAsyncThunk('cache/saveData', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/registration/v1/user-data/save`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const dataList = createAsyncThunk('cache/dataList', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/registration/v1/user-data/list`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})


export const cacheDataSlice = createSlice({
    name: 'cacheData',
    initialState: {
        currentData: null,
        drafts: [],
        effected: false
    },
    reducers: {
        handleDraftData: (state, action) => {
            state.drafts.push(action.payload)
        },
        handleDraftDataClean: (state) => {
            state.drafts = []
        }
    },
    extraReducers: {
        [dataList.fulfilled](state, action) {
            state.currentData = action.payload?.data
        },
        [saveData.fulfilled](state) {
            state.effected = false
        },
        [saveData.pending](state) {
            state.effected = true
        }
    }
})

export const {handleDraftData, handleDraftDataClean} = cacheDataSlice.actions

export default cacheDataSlice.reducer